import React from 'react'
import SideNav from '../../components/SideNav'
import MainDashboard from '../../components/admin/Dashboard'
import Header from '../../components/Header'
import CTAApplicants from '../../components/admin/CTAApplicants'
import Users from '../../components/admin/Users'
export default function Instructors() {
  return (
    <>
    <Header/>
    <SideNav/>
    <Users/>
    </>
  )
}
